import { Box, Image } from '@joinrepublic/dls-ui-kit';

import { INewsPost } from './types';

export const NewsCard = ({
  newsPost: { title, href, coverImage, video },
}: {
  newsPost: INewsPost;
}) => (
  <Box
    as="article"
    w={{ base: '320px', sm: '440px', md: '510px' }}
    overflow="hidden"
    borderRadius={{ base: 'lg', sm: 'xl' }}
    bgColor="grey.100"
  >
    <Box as="a" href={href} display="block" className="group">
      {(coverImage && (
        <Image
          alt={title}
          src={coverImage.url}
          srcSet={`${coverImage.url2x} 2x`}
          w="full"
          aspectRatio="486/320"
          objectFit="cover"
          draggable="false"
          transition="transform 1.5s ease-out"
          _groupHover={{ transform: 'scale(1.025)' }}
        />
      )) ||
        (video && (
          <video
            src={video.url}
            poster={video.poster}
            controls={false}
            autoPlay={true}
            loop={true}
            muted={true}
            playsInline={true}
            width="100%"
            style={{ objectFit: 'cover', aspectRatio: '486/320' }}
          />
        ))}
    </Box>
  </Box>
);
